import { configureStore } from "@reduxjs/toolkit";
import authReducer from "./authSlice";
import goldRateReducer from "./goldRateSlice";
import userReducer from "./userSlice";
import productsReducer from "./productsSlice";
import productTagsReducer from "./productTagSlice";
import loadingReducer from "./loadingSlice";
import errorReducer from "./errorSlice";
import billsReducer from "./billsSlice";
import diamondRateReducer from "./diamondRateSlice";
import fileReducer from "./filesSlice";
import customersReducer from "./customersSlice";
import totalProductsCountReducer from "./productsCountSlice";
import insuranceReducer from "./insuranceSlice";
import goldEtfReducer from "./goldEtfSlice";
import shoppingBucketReducer from "./shoppingBucketSlice";

const store = configureStore({
    reducer: {
        auth: authReducer,
        goldRate: goldRateReducer,
        user: userReducer,
        products: productsReducer,
        customers: customersReducer,
        tags: productTagsReducer,
        loading: loadingReducer,
        error: errorReducer,
        diamondRates: diamondRateReducer,
        files: fileReducer,
        totalProductsCount: totalProductsCountReducer,
        bills: billsReducer,
        insurance: insuranceReducer,
        goldEtfs: goldEtfReducer,
        shoppingBucket: shoppingBucketReducer,
    },
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: false,
        }),
})
export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;

// Hook to use `AppDispatch` type
export default store;